import { render, staticRenderFns } from "./systemUpdateNotice.vue?vue&type=template&id=16393f60&scoped=true"
import script from "./systemUpdateNotice.vue?vue&type=script&lang=js"
export * from "./systemUpdateNotice.vue?vue&type=script&lang=js"
import style0 from "./systemUpdateNotice.vue?vue&type=style&index=0&id=16393f60&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16393f60",
  null
  
)

export default component.exports